<div [ngClass]="containerClasses">
  <ng-content></ng-content>
</div>
